import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form, ListGroup, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import { Positions } from "../../Languages/vars/Positions";
import { $crud } from "../../helper/CrudFactory";
import { convertBranchRole } from "../../helper/convertor";
import InviteExternalComponent from "../../components/InviteExternalComponent";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { object } from "prop-types";
import { Oval } from 'react-loader-spinner';
import "./CompanyUser.css";


const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function CompanyUser(props) {
  const { isGerm, strings } = React.useContext(LanguageContext);
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [userList, setUsersList] = useState([]);
  const [showPositionDialog, setPositionDialog] = useState(false);
  const [employeePosition, setEmployeePosition] = useState();
  const [userId, setUserId] = useState();
  const [isInviteByLink, setInviteByLink] = useState(false);
  const [viewLoader, setViewLoader] = useState(false)
  const [companyId, setCompanyId] = useState("");
  const [allToSearch, setAllToSearch] = useState([])
  const [allToSearchBack, setAllToSearchBack] = useState([])
  const [isKjuup, setIsKjuup] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [loadingMore, setLoadingMore] = useState(false)
  const [totalPages, setTotalPages] = useState(1)
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isSearching, setIsSearching] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const searchTimeoutRef = useRef(null);
  const positions = Positions;
  const [company, setCompany] = useState(null);
  const [compDetail, setCompanyDetail] = useState(null);
  const [deeplink, setDeepLink] = useState("");
  const getCompanies = async (page = 1, isLoadMore = false, searchQuery = "") => {
    const id = props.match.params.id;
    const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : "";
    const { data } = await callAPI(`/company/${id}/getUsersToAdd?page=${page}&limit=20${searchParam}`, {}, "GET");
    
    console.log('API Response:', data); // Debug log
    
    if (isLoadMore) {
      // Append new users to existing list
      const newUsers = [...allToSearchBack, ...data.users];
      setAllToSearchBack(newUsers);
      // Recreate the list with all users
      await CreateList(newUsers);
    } else {
      // Initial load or new search
      setAllToSearchBack(data.users);
      await CreateList(data.users);
    }
    
    // Update pagination state
    setCurrentPage(page);
    
    // Check if we have more data - if data.users is empty, it means no more data
    const hasMoreData = data.users && data.users.length > 0;
    
    setTotalPages(data.totalCnt || page);
    setHasMore(hasMoreData);
    setLoadingMore(false);
    setIsSearching(false);
    setIsTyping(false);
    
    console.log('Pagination state:', { 
      page, 
      totalPages: data.totalCnt, 
      hasMore: hasMoreData,
      usersCount: data.users?.length,
      isEmpty: !data.users || data.users.length === 0,
      searchQuery
    }); // Debug log
  };

  const CreateList = async (users) => {
    const arr = _.uniqBy(
      users.map((user) => {
        let name = { name: user.lastName.trim()[0].toUpperCase() };
        return name;
      }),
      "name"
    );
    const updatedArr = _.sortBy(arr, ["name"]);
    const usersList = updatedArr.map((a) => {
      let names = users.filter((u) => u.lastName.trim()[0].toUpperCase() === a.name);
      a.names = names;
      return a;
    });
    setUsers(usersList);
    setUsersList(usersList);
    setAllToSearch(users)
    setAllToSearchBack(users)
  };

  const prevDebouncedSearchRef = useRef("");

  const getCompanyDetails = async () => {
    const id = props.match.params.id;
    const datax = await callAPI(`/company/${id}/profile`, {}, "GET");
    await setCompanyDetail(datax.data.profile);
    const { data } = await callAPI(`/company/${id}/companyById`, {}, "GET");
    await setCompany(data.company);
  };

  const getInviteLink = async () => {
    if (!compDetail) return;
    const id = props.match.params.id;
    const { data } = await callAPI(
      `/invite-user/deeplink`,
      (props.match.params.departmentId && props.match.params.departmentId !== 'null') ? {
        inviteType: "company",
        company: id,
        deptLocation: props.match.params.departmentId,
        isImportCompany: compDetail.isImport ? 1 : 0
      } : {
        inviteType: "company",
        company: id,
        isImportCompany: compDetail.isImport ? 1 : 0
      },
      "POST"
    );
    if (data.status) {
      let splitToken = data?.deeplinkUrl?.split("/");
      let getToken = splitToken[splitToken?.length - 1];
      let webLinkPayload = {
        data: {
          locallyIndex: true,
          title: "Kjuup",
          ratingAverage: 4.2,
          registraTionToken: getToken,
          isKjuupPlus: compDetail.isKjuup ? "true" : "false",
          deptLocation: props.match.params.departmentId,
          isImportCompany: compDetail.isImport ? 1 : 0
        },
      };
      window.branch.link(webLinkPayload, (err, link) => {
        setDeepLink(link);
      });
    }
  };

  useEffect(() => {
    setCompanyId(props.match.params.id);
    getCompanies();
    getCompanyDetails();
  }, []);
  
  useEffect(() => {
    if (compDetail) {
      getInviteLink();
    }
  }, [compDetail]);

  useEffect(() => {
    if (props.location.state) {
      setIsKjuup(props.location.state.isKjuup)
    }
  }, [props])

  const handleCopyLink = async () => {
    const receiverMessage = deeplink
      ? `${strings.company_sender_message
        }`.replaceAll("company name", company?.name || "") + `\n\n${deeplink}`
      : "";
    
    if (receiverMessage) {
      navigator.clipboard.writeText(receiverMessage).then((r) => {
        $crud.notify({
          type: "success",
          message: strings.link_copied,
        });
      });
    }
  };
  const [search, setSearch] = useState("");

  // Handle search - trigger on 3rd character or when cleared
  useEffect(() => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // If search is empty, reset to initial state
    if (!search.trim()) {
      setDebouncedSearch("");
      setIsSearching(false);
      setIsTyping(false);
      return;
    }

    // Show loader instantly when user starts typing
    setIsTyping(true);

    // If search has 3+ characters, trigger search immediately
    if (search.trim().length >= 3) {
      setIsSearching(true);
      setDebouncedSearch(search.trim());
      setCurrentPage(1);
      setUsers([]);
      setAllToSearch([]);
      setAllToSearchBack([]);
      setHasMore(true);
    } else {
      // If less than 3 characters, clear results but keep typing indicator
      setDebouncedSearch("");
      setUsers([]);
      setAllToSearch([]);
      setAllToSearchBack([]);
      setHasMore(false);
      setIsSearching(false);
    }
  }, [search]);

  // Load users when debounced search changes
  useEffect(() => {
    const wasSearching = prevDebouncedSearchRef.current && prevDebouncedSearchRef.current !== "";
    const isNowEmpty = debouncedSearch === "";
    
    if (isNowEmpty && wasSearching) {
      // Search was cleared - reload initial data
      setCurrentPage(1);
      setUsers([]);
      setAllToSearch([]);
      setAllToSearchBack([]);
      setHasMore(true);
      setIsSearching(false);
      setIsTyping(false);
      getCompanies(1, false, "");
    } else if (debouncedSearch !== undefined && debouncedSearch !== "") {
      // Perform search
      getCompanies(1, false, debouncedSearch);
    }
    
    prevDebouncedSearchRef.current = debouncedSearch;
  }, [debouncedSearch]);

  // Load more when page changes (for pagination)
  useEffect(() => {
    if (currentPage > 1) {
      getCompanies(currentPage, true, debouncedSearch || "");
    }
  }, [currentPage]);

  const loadMore = async () => {
    console.log('loadMore called:', { loadingMore, hasMore, currentPage, debouncedSearch }); // Debug log
    if (loadingMore || !hasMore || isSearching) return;
    
    setLoadingMore(true);
    const nextPage = currentPage + 1;
    console.log('Loading page:', nextPage); // Debug log
    setCurrentPage(nextPage);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100;
    
    console.log('Scroll event:', { scrollTop, scrollHeight, clientHeight, isNearBottom, hasMore, loadingMore, debouncedSearch }); // Debug log
    
    // Allow pagination for both search and non-search results
    if (isNearBottom && hasMore && !loadingMore && !isSearching) {
      console.log('Triggering loadMore'); // Debug log
      loadMore();
    }
  };

  const filterUsers = async (searchValue) => {
    setSearch(searchValue);
  };

  const addUser = async (id) => {
    const confirmMsg = isGerm ? "Einladung zur Firma bestätigen?" : "Confirm invitation to the company?"
    const okText = strings.confirm;
    const cancelText = strings.cancel;
    await $crud.confirm({
      title: confirmMsg,
      textContent: "",
      options: {
        ok: okText,
        cancel: cancelText
      }
    });
    handleSubmit(id);
  };
  const hidePositionDialog = () => {
    if (isInviteByLink) setInviteByLink(false);
    setPositionDialog(false);
  };

  const handleSubmit = async (id) => {
    console.log(props.match.params)
    setViewLoader(true)
    const { data } = await callAPI(
      `/company/request`,
      null,
      "POST",
      (props.match.params.departmentId && props.match.params.departmentId !== "null" && props.match.params.departmentId !== "undefined") ? {
        companyId: props.match.params.id,
        userId: id,
        lang: `${isGerm ? 'de' : 'en'}`,
        deptLocation: props.match.params.departmentId
      } : {
        companyId: props.match.params.id,
        userId: id,
        lang: `${isGerm ? 'de' : 'en'}`
      }
    );
    $crud.notify({
      type: data.status ? "success" : "error",
      message: data.message,
    });
    let tmp = [...users]
    for (let i = 0; i < users.length; i++) {
      for (let j = 0; j < users[i].names.length; j++) {
        if (users[i].names[j].id == id) {
          tmp[i].names.splice(j, 1)
          if (tmp[i].names.length == 0) {
            tmp.splice(i, 1)
          }
        }
      }
    }
    let ttx = allToSearch.filter((e) => {
      return e.id != id
    })
    let ttxx = allToSearchBack.filter((e) => {
      return e.id != id
    })
    setAllToSearch(ttx)
    setAllToSearchBack(ttxx)
    setUsers(tmp)
    setViewLoader(false)
  };

  const handleInviteUser = () => {
    setInviteByLink(true);
    setPositionDialog(true);
  };

  return (
    <React.Fragment>
      <div className="company_section w-300 company_list add-company-user company-user">
        {viewLoader && (
          <div className="website_loader">
            <div className="loader" />
          </div>
        )}
        <div className="company_header company-user__header">
          <div class="heading_icon m-0">
            <Link
              to={{ pathname: "/cockpit", search: `?tab=company&company=${encodeURIComponent(companyId)}` }}
              className={isKjuup ? "main_heading main_heading-internal" : "main_heading"}
            >
              <span className="material-symbols-outlined material-arrow-left">
                keyboard_arrow_left
              </span>
              {strings.add_employee}
            </Link>
          </div>
        </div>
        <div className="search_div company-user__search">
          <div className="search">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Control
                autocomplete="off"
                value={search}
                type="search"
                placeholder="Search"
                onChange={(e) => {
                  const value = e.target.value;
                  filterUsers(value);
                }}
              />
            </Form.Group>
          </div>
        </div>

        <CustomScrollbars
          autoHide
          autoHideTimeout={500}
          autoHideDuration={200}
          className="bottom-bar"
          onScroll={handleScroll}
        >
          {/* Invite link section - commented out for potential re-implementation
          <div style={{ marginBottom: 10, display: "flex", flexDirection: "column", padding: "0 16px" }}>
            <div style={{ 
              backgroundColor: "#fff", 
              marginBottom: 20, 
              marginTop: 10, 
              alignSelf: "flex-start", 
              padding: "16px 20px",
              borderRadius: 12,
              width: '100%',
              maxWidth: 'fit-content'
            }}>
              <p style={{ 
                width: "100%", 
                maxWidth: "600px",
                fontSize: "var(--kjuup-type-body)", 
                color: "#737373", 
                marginBottom: 16,
                lineHeight: '1.5',
                margin: '0 0 16px 0'
              }}>
                {company?.name ? (
                  `${strings.company_sender_message
                  }`.replaceAll("company name", company?.name || "")
                ) : (
                  <span>Loading...</span>
                )}
              </p>
              <div onClick={deeplink ? handleCopyLink : undefined} className="pointer" style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: 8,
                cursor: deeplink ? 'pointer' : 'default'
              }}>
                <span className="material-symbols-outlined copy-link-icon" style={{ color: 'var(--kjuup-accent)' }}>content_copy</span>
                <span style={{
                  fontSize: "14px",
                  color: "var(--kjuup-accent)",
                  fontWeight: 500
                }}>
                  {strings.copy_link}
                </span>
              </div>
              <div style={{ 
                marginTop: 12, 
                fontSize: "12px",
                color: "#737373", 
                fontStyle: "italic"
              }}>
                {(() => {
                  const text = strings.link_expire;
                  return text
                    .replace('72 hours', '10 days')
                    .replace('72 ore', '10 giorni')
                    .replace('72 Stunden', '10 Tage')
                    .replace('72 heures', '10 jours')
                    .replace('72 horas', '10 días')
                    .replace('72 uur', '10 dagen')
                    .replace('72 timer', '10 dager')
                    .replace('72 timmar', '10 dagar')
                    .replace('72 tuntia', '10 päivää')
                    .replace('72 godziny', '10 dni')
                    .replace('72 saat', '10 gün')
                    .replace('72 ώρες', '10 ημέρες')
                    .replace('72 hodin', '10 dní')
                    .replace('72 óra', '10 nap')
                    .replace('72 de ore', '10 zile')
                    .replace('72 sata', '10 dana')
                    .replace('72 ur', '10 dni')
                    .replace('72小时', '10天')
                    .replace('72 घंटे', '10 दिन')
                    .replace('72 ساعة', '10 أيام')
                    .replace('72時間', '10日')
                    .replace('72시간', '10일')
                    .replace('72 giờ', '10 ngày')
                    .replace('72 jam', '10 hari')
                    .replace('72 மணி', '10 நாட்கள்')
                    .replace('72 గంటలు', '10 రోజులు')
                    .replace('72 часа', '10 дней')
                    .replace('72 часа', '10 дни');
                })()}
              </div>
            </div>
          </div>
          */}

          <div className="invite p-2 company-user__list">
            <div className="admin_right" >
              {!debouncedSearch && !isTyping &&
                <div className="admin-content company-user__results">
                  {users &&
                    users.flatMap((user) =>
                      _.sortBy(
                        user.names,
                        [(us) => us?.lastName?.toLowerCase()],
                        ["lastName"]
                      ).map((u, i) => (
                        <div 
                          key={`${user.name}-${i}`}
                          className="admin-contact company-user__contact"
                          onClick={(e) => {
                            addUser(u.id)
                          }}
                        >
                          <div className="row m-0 align-items-center">
                            <div className="col-md-10 p-0">
                              <div className="admin-control">
                                {u.avatar ?
                                  <ImageWithPlaceholder
                                    width={30}
                                    height={30}
                                    className="news_profile company-user__avatar"
                                    src={BASE_URL + u.avatar}
                                    alt="G"
                                    fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                    isKjuup={u.isKjuup || u.companies?.some(c => c.isKjuup)}
                                  />
                                  :
                                  <img
                                    width={30}
                                    height={30}
                                    className={`news_profile company-user__avatar${(u.isKjuup || u.companies?.some(c => c.isKjuup)) ? " company-user__avatar--internal" : ""}`}
                                    src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                    alt="Generic placeholder"
                                  />
                                }
                                <h5>
                                  {u.fullName}
                                  <span>{convertBranchRole(u.details, isGerm)}</span>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                </div>
              }
              {isTyping && !debouncedSearch && (
                <div className="admin-content company-user__results">
                  <div className="company-user__loader">
                    <Oval
                      height={30}
                      width={30}
                      color={isKjuup ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={true}
                      ariaLabel='oval-loading'
                      secondaryColor={'#f7f7f7'}
                      strokeWidth={5}
                      strokeWidthSecondary={5}
                    />
                  </div>
                </div>
              )}
              {debouncedSearch &&
                <div className="admin-content company-user__results">
                  {(isSearching || isTyping) && allToSearch.length === 0 && (
                    <div className="company-user__loader">
                      <Oval
                        height={30}
                        width={30}
                        color={isKjuup ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor={'#f7f7f7'}
                        strokeWidth={5}
                        strokeWidthSecondary={5}
                      />
                    </div>
                  )}
                  {!isSearching && !isTyping && allToSearch && allToSearch.length === 0 && (
                    <div className="d-flex justify-content-center align-items-center py-3 text-muted">
                      <small>
                        {strings.no_results_found || "No results found"}
                      </small>
                    </div>
                  )}
                  {allToSearch &&
                    allToSearch.length > 0 &&
                    _.sortBy(
                      allToSearch,
                      [(us) => us?.lastName?.toLowerCase()],
                      ["lastName"]
                    ).map((u, i) => (
                      <div 
                        key={i}
                        className="admin-contact company-user__contact"
                        onClick={(e) => {
                          addUser(u.id)
                        }}
                      >
                        <div className="row m-0 align-items-center">
                          <div className="col-md-10 p-0">
                            <div className="admin-control">
                              {u.avatar ?
                                <ImageWithPlaceholder
                                  width={30}
                                  height={30}
                                  className="news_profile company-user__avatar"
                                  src={BASE_URL + u.avatar}
                                  alt="G"
                                  fallbackSrc={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                />
                                :
                                <img
                                  width={30}
                                  height={30}
                                  className="news_profile company-user__avatar"
                                  src={(process.env.PUBLIC_URL + "/assets/img/head.svg")}
                                  alt="Generic placeholder"
                                />
                              }
                              <h5>
                                {u.fullName}
                                <span>{convertBranchRole(u.details, isGerm)}</span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              }
            </div>
          </div>
          
          {/* Bottom Loader */}
          {loadingMore && (
            <div className="company-user__loader">
              <Oval
                height={30}
                width={30}
                color={isKjuup ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor={'#f7f7f7'}
                strokeWidth={5}
                strokeWidthSecondary={5}
              />
            </div>
          )}
          
        
          
          {/* End of results indicator */}
          {!hasMore && !debouncedSearch && allToSearchBack.length > 0 && (
            <div className="d-flex justify-content-center align-items-center py-3 text-muted">
              <small>
                {strings.no_more_users_to_load}
              </small>
            </div>
          )}
          {!hasMore && debouncedSearch && allToSearchBack.length > 0 && (
            <div className="d-flex justify-content-center align-items-center py-3 text-muted">
              <small>
                {isGerm ? DE.no_more_search_results || "Keine weiteren Suchergebnisse" : EN.no_more_search_results || "No more search results"}
              </small>
            </div>
          )}
        </CustomScrollbars>
      </div>
      <>
        <Modal
          show={showPositionDialog}
          onHide={hidePositionDialog}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {strings.position_within_company}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup variant="flush">
              {positions.map((position) => (
                <div
                  onClick={(e) => setEmployeePosition(position.name_en)}
                  key={position.id}
                  className="form-check p"
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id={position.id}
                    value={position.name_en}
                  />
                  <label
                    className="form-check-label pointer"
                    htmlFor={position.id}
                  >
                    {isGerm ? position.name_de : position.name_en}
                  </label>
                </div>
              ))}
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="kj-btn kj-btn--secondary" onClick={hidePositionDialog}>
              Close
            </button>
            <button type="button" className="kj-btn kj-btn--outline" onClick={handleSubmit}>
              Ok
            </button>
          </Modal.Footer>
        </Modal>
      </>
    </React.Fragment>
  );
}

export default CompanyUser;
